import { useCallback, useEffect, useRef, useState } from 'react';
import { useApiGet } from '@sierralabs/core-ui';
export function useGetComponents() {
    const [path, setPath] = useState('');
    const [siteComponents, setSiteComponents] = useState([]);
    const siteComponentMapRef = useRef({});
    const { data, isLoading, error, get } = useApiGet(path);
    // fetch site when path is set
    useEffect(() => void (path && get()), [path, get]);
    // clear out path state after fetching
    useEffect(() => (siteComponents ? setPath('') : error ? setPath('') : undefined), [siteComponents, error]);
    const transformComponents = useCallback((components, parent) => {
        for (const component of components) {
            siteComponentMapRef.current[component.id] = component;
            if (parent)
                component.parent = parent;
            if (component.children) {
                transformComponents(component.children, component);
            }
        }
    }, []);
    useEffect(() => {
        // transform before set to properly re-render with parents
        if (data) {
            transformComponents(data);
            setSiteComponents(data);
        }
    }, [data, transformComponents]);
    // set component parent recursively when site components are loaded from the
    // server side.
    useEffect(() => {
        if (siteComponents) {
            transformComponents(siteComponents);
        }
    }, [siteComponents, transformComponents]);
    /**
     * replace a component in the main siteComponents/siteComponentMap object.
     * This method will re-assign parent and children references to the new
     * component object. This is used when sending components between window and
     * iframe.
     */
    const replaceComponent = useCallback((component) => {
        const siteComponentMap = siteComponentMapRef.current;
        if (component.parent) {
            const parent = siteComponentMap[component.parent.id];
            component.parent = parent; // reference the correct parent
            if (!parent.children)
                parent.children = [];
            const index = parent.children.findIndex(c => c.id === component.id);
            // make sure the site context parent children have the correct reference
            if (index > -1) {
                parent.children[index] = component;
            }
            else {
                parent.children.push(component);
            }
        }
        // replace component in main site context
        siteComponentMap[component.id] = component;
        component.children && transformComponents(component.children, component);
    }, [transformComponents]);
    /**
     * Get site components from server side.
     */
    const getSiteComponents = useCallback((siteId) => {
        console.log('getSiteComponents');
        setPath(`sites/${siteId}/components`);
    }, []);
    return {
        siteComponents,
        siteComponentMap: siteComponentMapRef.current,
        loadingSiteComponents: isLoading,
        loadingSiteComponentError: error,
        setSiteComponents,
        getSiteComponents,
        replaceComponent
    };
}
//# sourceMappingURL=useGetComponents.js.map